import { maxLength, minLength, required } from 'vuelidate/lib/validators';

const validations = {
    formValues: {
        subject: {
            required,
            minLength: minLength(5),
            maxLength: maxLength(50)
        },
        object: {
            required
        },
        asignee: {
            required
        },
        expires_on: {
            required
        },
        blocking: {
            required
        },
        category: {
            required
        },
        description: {
            required,
            minLength: minLength(10)
        }
    }
};

export default validations;
